var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "db center w-100" }, [
    _c(
      "a",
      {
        staticClass:
          "db absolute right-0 mr1 mt1 grow pointer nav-toggle vid-modal-toggle is-clicked z-9002",
        on: {
          click: function ($event) {
            return _vm.$emit("close")
          },
        },
      },
      [
        _c("span", { staticClass: "line" }),
        _vm._v(" "),
        _c("span", { staticClass: "line" }),
        _vm._v(" "),
        _c("span", { staticClass: "line" }),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "db center relative" }, [
      _c(
        "section",
        { staticClass: "relative mw8 center pv4 pv5-ns tl bg-navy" },
        [
          _c("div", { staticClass: "relative container-fluid" }, [
            _c("div", { staticClass: "relative center mw6" }, [
              _c(
                "h2",
                { staticClass: "f3 mv3 tc ttu is-lorano-bold is-white" },
                [_vm._v(_vm._s(_vm.title))]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "f5 f4-ns lh-copy is-white cms-content" },
                [_vm._v(_vm._s(_vm.text))]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "f5 f4-ns lh-copy is-white cms-content" },
                [_vm._v(_vm._s(_vm.text))]
              ),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }